/** Cross-tab public site cache invalidation + version busting. */
export const SITE_CACHE_VERSION_KEY = "site_cache_v";

const CHANNEL_NAME = "site-cache";

let channel = null;

function getChannel() {
  if (typeof BroadcastChannel === "undefined") return null;
  if (!channel) channel = new BroadcastChannel(CHANNEL_NAME);
  return channel;
}

export function getSiteCacheVersion() {
  try {
    return localStorage.getItem(SITE_CACHE_VERSION_KEY) || "";
  } catch {
    return "";
  }
}

export function bumpSiteCacheVersion(serverVersion) {
  const v = String(serverVersion || Date.now());
  try {
    localStorage.setItem(SITE_CACHE_VERSION_KEY, v);
  } catch {
    /* ignore */
  }
  try {
    getChannel()?.postMessage({ type: "invalidate", version: v });
  } catch {
    /* ignore */
  }
  return v;
}

export function clearSiteSessionCaches() {
  try {
    sessionStorage.removeItem("site_settings_v1");
    sessionStorage.removeItem("site_home_v1");
  } catch {
    /* ignore */
  }
}

export function listenSiteCacheInvalidation(onInvalidate) {
  if (typeof window === "undefined") return () => {};

  const handler = (version) => {
    if (typeof onInvalidate === "function") onInvalidate(version);
  };

  const onStorage = (e) => {
    if (e.key === SITE_CACHE_VERSION_KEY && e.newValue) {
      handler(e.newValue);
    }
  };

  const onMessage = (e) => {
    if (e?.data?.type === "invalidate" && e.data.version) {
      handler(String(e.data.version));
    }
  };

  window.addEventListener("storage", onStorage);
  const ch = getChannel();
  ch?.addEventListener("message", onMessage);

  return () => {
    window.removeEventListener("storage", onStorage);
    ch?.removeEventListener("message", onMessage);
  };
}

export function upsertProfilePreload(photoUrl, mediaUrlFn) {
  if (!photoUrl || typeof document === "undefined") return;
  const href = typeof mediaUrlFn === "function" ? mediaUrlFn(photoUrl) : photoUrl;
  if (!href) return;
  const id = "profile-photo-preload";
  let link = document.getElementById(id);
  if (!link) {
    link = document.createElement("link");
    link.id = id;
    link.rel = "preload";
    link.as = "image";
    document.head.appendChild(link);
  }
  if (link.getAttribute("href") !== href) {
    link.setAttribute("href", href);
    link.setAttribute("fetchpriority", "high");
  }
}
